const Axios = require('axios');
const Swal = require('sweetalert2');

require('/vendor/inputmask/inputmask.min')
window.toastr = require('/vendor/toastr/toastr.min')

window.showOrcamentoModal = (produtoId) => {
    if (produtoId) {
        const prefix = 'orc_'
        $(`[name="${prefix}produto_id"]`).val(produtoId)
    }

    $('#orcamentoModal').modal('show')
}

window.submitOrcamentoModal = () => {
    const prefix = 'orc_';

    Swal.fire({
        text: "Por favor, espere.",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading()
        }
    });

    const data = {
        'produto_id': $(`[name="${prefix}produto_id"]`).val(),
        'nome': $(`[name="${prefix}nome"]`).val(),
        'celular': $(`[name="${prefix}celular"]`).val(),
        'email': $(`[name="${prefix}email"]`).val(),
    }

    Axios.post('/produto/requestquotation', data)
        .then(function (response) {
            Swal.close();

            if (response.data.success_message) {
                toastr.success(response.data.success_message);
                $('#orcamentoModal').modal('hide')
            } else if (response.data.error_message) {
                toastr.error(response.data.error_message)
            } else {
                toastr.error('Ocorreu um erro inesperado.')
            }
        }).catch(function (error) {
            Swal.close();

            const data = error.response.data;
            if (data.errors) {
                showErrorMessages(data.errors, prefix);
            } else {
                toastr.error('Ocorreu um erro inesperado.')
            }
        });
}

window.showVendaModal = (produtoId) => {
    if (produtoId) {
        const prefix = 'sale_'
        $(`[name="${prefix}produto_id"]`).val(produtoId)
    }

    $('#vendaModal').modal('show')
}

window.submitVendaModal = () => {
    const prefix = 'sale_';

    Swal.fire({
        text: "Por favor, espere.",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading()
        }
    });

    const data = {
        'produto_id': $(`[name="${prefix}produto_id"]`).val(),
        'nome': $(`[name="${prefix}nome"]`).val(),
        'celular': $(`[name="${prefix}celular"]`).val(),
        'email': $(`[name="${prefix}email"]`).val(),
        'end_cep': $(`[name="${prefix}end_cep"]`).val(),
        'end_rua': $(`[name="${prefix}end_rua"]`).val(),
        'end_complemento': $(`[name="${prefix}end_complemento"]`).val(),
        'end_num': $(`[name="${prefix}end_num"]`).val(),
        'end_bairro': $(`[name="${prefix}end_bairro"]`).val(),
        'end_cidade': $(`[name="${prefix}end_cidade"]`).val(),
        'end_estado': $(`[name="${prefix}end_estado"]`).val(),
    }

    Axios.post('/produto/requestsale', data)
        .then(function (response) {
            Swal.close();

            if (response.data.success_message) {
                $('#vendaModal').modal('hide');
                redirectTo(`/payment/${response.data.uuid}`);
            } else if (response.data.error_message) {
                toastr.error(response.data.error_message)
            } else {
                toastr.error('Ocorreu um erro inesperado.')
            }
        }).catch(function (error) {
            Swal.close();

            const data = error.response.data;
            if (data.errors) {
                showErrorMessages(data.errors, prefix);
            } else {
                toastr.error('Ocorreu um erro inesperado.')
            }
        });
}

const redirectTo = (url) => {
    window.location.href = url;
}

const showErrorMessages = (errors, prefix = '') => {
    $(`[${prefix}errors]`).addClass('d-none');

    let message;
    for (let field in errors) {
        message = errors[field];
        $(`[error-${prefix}${field}]`).removeClass('d-none');
        $(`[error-${prefix}${field}] .error`).text(message[0]);
    }
}

window.getAddressByCEP = async (cep) => {
    const formattedCep = cep.replace(/\D/g, '');

    if (formattedCep.length !== 8) {
        return {
            "erro": true
        };
    }

    const apiUrl = 'https://viacep.com.br';

    try {
        const response = await Axios.get(`${apiUrl}/ws/${formattedCep}/json`);
        return response.data;
    } catch (e) {
        return {
            "erro": true
        };
    }
}

$(function () {
    $('[name="sale_end_cep"]').on('focusout', async function () {
        const $input = $(this);

        if (!$input.val()) return;

        const data = await getAddressByCEP($input.val());

        if (data.erro) {
            toastr.error('O CEP informado é inválido.');
            $input.val('');
            return;
        } else {
            $('[name="sale_end_rua"]').val(data.logradouro);
            $('[name="sale_end_bairro"]').val(data.bairro);
            $('[name="sale_end_cidade"]').val(data.localidade);
            $('[name="sale_end_estado"]').val(data.uf);
        }
    })
});